import { Component } from '@angular/core';

@Component({
  selector: 'sai-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
}
